__turbopack_context__.v({
  "chevron": "yD-7ea_chevron",
  "chevronOpen": "yD-7ea_chevronOpen",
  "expand": "yD-7ea_expand",
  "panelCell": "yD-7ea_panelCell",
  "panelGrid": "yD-7ea_panelGrid",
  "panelInner": "yD-7ea_panelInner",
  "trigger": "yD-7ea_trigger",
  "triggerCell": "yD-7ea_triggerCell",
});
